import { useSelector } from 'react-redux';
import { activeChatbotIdSelector } from '@mm/state/selectors/viewSelectors';
import { useAutomationsCRUDActions } from '@mm/state/actions/automationActions';

export const useAutomationStats = () => {
  const botId = useSelector(activeChatbotIdSelector);

  const automationsCRUDActions = useAutomationsCRUDActions();

  const fetchStats = async (ids: string[]) => {
    if (ids?.length) {
      const chain = ids.map(id =>
        automationsCRUDActions.retrieveStatistics(botId, parseInt(id, 10)),
      );

      try {
        await Promise.all(chain);
      } catch (err) {
        console.error(err);
      }
    }
  };

  return { fetchStats };
};
